<template>
	<div class="snapshot-button btn-outline-primary">
		<icon :title="$t('snapshot.title')" icon="database" class="snapshot-button-icon" @click="toggleList" />
		<div class="snapshot-button-list-container" id="snapshotButtonContainer">
			<List v-show="listVisible" ref="list" tabindex="0" :data="buttons" :options="componentOptions.list" @enter-pressed="tabClicked" @update:modelValue="tabClicked" />
		</div>
	</div>
</template>

<script>
	import List from '~/components/general/nikan-list'
	import $sc from "~/plugins/shortcut.collection"
	import NikanAnimation from '~/plugins/anime'
	import { SnapshotTypes } from '~/interfaces/plugins/snapshot'
	export default {
		name: 'snapshot-button',
		emits: ['visibility-changed'],
		components: {
			List
		},
		props: {
			options: { type: Function, required: true }
		},
		watch: {
			listVisible: {
				handler(val) {
					if (val)
						this.prepareButtons()
				}
			}
		},
		mounted() {
			this.animeInstance = new NikanAnimation('#snapshotButtonContainer',
				{
					opacity: [0, 1],
					easing: 'linear',
					duration: 200,
				})

			this.settings = this.options()
		},
		data() {
			return {
				listVisible: false,
				animeInstance: null,
				oldFocusedElement: null,
				settings: {},
				buttons: [],
				componentOptions: {
					list: {
						multiSelection: false,
						display: (item) => item.title
					}
				},
			}
		},
		methods: {
			tabClicked(val) {
				if (val.disabled)
					return

				val.handle()
				this.listVisible = false
			},
			prepareButtons() {
				this.buttons = [
					{
						title: this.$t('snapshot.buttons.take-manual'),
						key: `take-${SnapshotTypes.MANUAL}`,
						handle: (button, page, e) => {
							this.settings.snapshotInstance.takeSnapshot(SnapshotTypes.MANUAL)
							this.$toast(this.$t('snapshot.m.snapshot-manul-taken'), { type: 'success' })
						},
					},
					{
						title: this.$t('snapshot.buttons.restore-manual'),
						disabled: !this.settings.snapshotInstance.userHasSnapshot(SnapshotTypes.MANUAL),
						handle: (button, page, e) => {
							var data = this.settings.snapshotInstance.restoreSnapshot(SnapshotTypes.MANUAL)

							if (data)
								this.settings.fillData(data)
						},
					},
					{
						title: this.$t('snapshot.buttons.restore-automatic'),
						disabled: !this.settings.snapshotInstance.userHasSnapshot(SnapshotTypes.AUTOMATIC),
						handle: (button, page, e) => {
							var data = this.settings.snapshotInstance.restoreSnapshot(SnapshotTypes.AUTOMATIC)

							if (data)
								this.settings.fillData(data)
						},
					}
				]
			},
			toggleList() {
				this.animeInstance.play()
				this.listVisible = !this.listVisible
				this.$emit('visibility-changed', this.listVisible)

				this.defer(() => {
					const list = this.$refs.list.$el

					if (this.listVisible && document.activeElement !== list) {
						this.oldFocusedElement = document.activeElement
						list.focus()
					}
					else {
						this.oldFocusedElement.focus()
					}

				}, 1)
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'take-manual-snapshot',
					shortcut: $sc.find('snapshot'),
					el: this.grandParent,
					context: this,
					handler: function (sender, e) {
						e.preventDefault()
						this.buttons.find(x => x.key === `take-${SnapshotTypes.MANUAL}`).handle()
					},
				})
			}
		},
	}
</script>

<style lang="less">
	@import "~/styles/snapshot-button.less";
</style>
